"use client";
import { jsx as o } from "react/jsx-runtime";
import * as t from "@radix-ui/react-collapsible";
import { forwardRef as r } from "react";
const p = ({ ...l }) => /* @__PURE__ */ o(t.Root, { "data-slot": "collapsible", ...l }), i = r(({ ...l }, e) => /* @__PURE__ */ o(t.CollapsibleTrigger, { "data-slot": "collapsible-trigger", ...l, ref: e }));
i.displayName = "CollapsibleTrigger";
const n = ({ ...l }) => /* @__PURE__ */ o(t.CollapsibleContent, { "data-slot": "collapsible-content", ...l });
export {
  n as CollapsibleContent,
  p as CollapsibleRoot,
  i as CollapsibleTrigger
};
